import React from "react";
import { Navigate } from "react-router-dom";

const DEFAULT_ALLOWED = ["pziPDtOgJiX06oGuJxNwxE"]; // your owner id

export default function AdminOnly({ children, allowedIds = DEFAULT_ALLOWED }) {
  const userId = localStorage.getItem("userId");
  if (!allowedIds.includes(userId)) return <Navigate to="/" replace />;
  return children;
}
